export {default as MapaC} from './components/mapa';



// WEBPACK FOOTER //
// src/modules/mapaGeneral/component.js